export {
  default,
  getStaticProps,
  getStaticPaths,
} from "app/smartphone/[slug]/page";
